import { Component, effect, ElementRef, inject, Signal, ViewChild } from '@angular/core';
import { EventTitleComponent } from './event-title/event-title.component';
import { NavigationComponent } from './navigation/navigation.component';
import { MenuComponent } from './menu/menu.component';
import { NeighborsComponent } from './neighbors/neighbors.component';
import { LegendComponent } from './legend/legend.component';
import { FullscreenToggleComponent } from "./fullscreen-toggle/fullscreen-toggle.component";
import { HyperlinkComponent } from './hyperlink/hyperlink.component';
import { DvmService } from '@services/dvm.service';
import anime from 'animejs';
import { BenefitsComponent } from './benefits/benefits.component';
import { VenueLayoutComponent } from './venue-layout/venue-layout.component';
import { LayoutService } from '@services/layout.service';
import { ActionButtonsComponent } from "../footer/action-buttons/action-buttons.component";
import { ViewerRouteParamsService } from '@services/viewer-route-params.service';


@Component({
    selector: 'app-topbar',
    imports: [
        NavigationComponent,
        MenuComponent,
        EventTitleComponent,
        NeighborsComponent,
        VenueLayoutComponent,
        BenefitsComponent,
        LegendComponent,
        HyperlinkComponent,
        FullscreenToggleComponent,
        ActionButtonsComponent
    ],
    templateUrl: './topbar.component.html',
    styleUrl: './topbar.component.css'
})
export class TopbarComponent {

  // VIEWCHILDS
  @ViewChild('topbarContainer', {static: true}) 
  private readonly topbarContainer!: ElementRef<HTMLElement>

  // SERVICES
  private readonly dvmService:       DvmService      = inject(DvmService);
  private readonly routeParams:      ViewerRouteParamsService = inject(ViewerRouteParamsService);

  // COMPONENT STATE
  public  readonly isMobile:         Signal<boolean> = inject(LayoutService).isMobile;
  protected readonly hyperlinkMode:  boolean         = this.routeParams.hasViewId;

  private readonly fullscreenChange = effect((): void => {
    this.toggleVisibility(!this.dvmService.isFullscreen());
  });


  private toggleVisibility(show: boolean): void {
    if (
      this.hyperlinkMode
      || !this.topbarContainer
      || this.topbarContainer.nativeElement.children.length < 3
    ) return;
    
    anime({
      targets: this.getVisibilityElements(),
      opacity: show ? 1 : 0,
      easing: 'easeInOutQuad',
      duration: 300,
    })

  }

  private getVisibilityElements(): HTMLElement[] {
        
    // Los 3 elementos hijos del navbar (Search/Menu, EventTitle/Neighbors, Dynamic Buttons)
    const navbarChildrenElements:   HTMLElement[] = Array.from(this.topbarContainer.nativeElement.children) as HTMLElement[],
        // Selector del componente de fullscreen toggle        
        toggleFullscreenSelector:   string        = 'app-fullscreen-toggle',        
        // Elementos fijos del navbar (Search/Menu, EventTitle/Neighbors)                                                                 
        fixedElements:              HTMLElement[] = [navbarChildrenElements[0], navbarChildrenElements[1]],                             
        // Filtramos los children del último elemento de la navbar exluyendo el toggle fullscreen y cogemos el primer child (no el host element)
        dynamicElements:            HTMLElement[] = Array.from(navbarChildrenElements[2].children).filter((element: Element)=> element.tagName.toLowerCase() !== toggleFullscreenSelector).map(el => el.firstChild as HTMLElement) as HTMLElement[];
         
    // Retornamos fixed elements y dynamic elements filtrados:
    return [...fixedElements, ...dynamicElements];

  }

}
